'use strict';

module.exports = bail;

function bail(err) {
  if (err) {
    throw err;
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/bail/index.js
// module id = 112
// module chunks = 14745957462784 35783957827783 96961042003272